(() => {
  if (window.productCardCountdownLoaded) return;
  window.productCardCountdownLoaded = true;

  const selector = 'product-card-countdown[data-countdown-until], product-page-countdown[data-countdown-until]';
  const second = 1000;
  const minute = second * 60;
  const hour = minute * 60;
  const day = hour * 24;

  const pad = (value) => String(value).padStart(2, '0');

  const updateCountdowns = () => {
    const now = Date.now();

    document.querySelectorAll(selector).forEach((element) => {
      const until = Number(element.dataset.countdownUntil) * second;
      const label = element.querySelector('[data-countdown-label]');

      if (!until || !label) return;

      const remaining = until - now;

      if (remaining <= 0) {
        element.dataset.expired = 'true';
        label.textContent = element.dataset.expiredLabel || 'Ended';
        return;
      }

      element.dataset.expired = 'false';

      const days = Math.floor(remaining / day);
      const hours = Math.floor((remaining % day) / hour);
      const minutes = Math.floor((remaining % hour) / minute);
      const seconds = Math.floor((remaining % minute) / second);

      label.textContent = `${days}d : ${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s`;
    });
  };

  updateCountdowns();
  window.setInterval(updateCountdowns, second);
  document.addEventListener('shopify:section:load', updateCountdowns);
})();
